import { CheckBoxWithLabelProps, DialogType } from '@tableau/widgets';
import React = require('react');
import { UpdateGrantLicenseModeDialog } from '../../app/groups/UpdateGrantLicenseModeDialog';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { ISiteRolePickerMenuScope } from '../helpers/SiteRolePickerMenuHelper';
import { IGroupInfo } from '../models/IGroupInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ModalInstance, ReactModalService } from './ReactModalService';

const groupUpdateDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

export interface ISetGrantLicenseModeLocalGroupsDialogScope extends ISiteRolePickerMenuScope {
}

export class UpdateLocalGroupGrantLicenseModeAction {
  public static $inject = [
    'AngularContextFactory'
  ];

  constructor(
    private angularContextFactory: AngularContextFactory
  ) { }

  public showUpdateGrantLicenseModeDialog(groupsToSet: Set<IGroupInfo>, scope: ng.IScope): ng.IPromise<any> {
    let modalInstance: ModalInstance;
    const dialogScope = <ISetGrantLicenseModeLocalGroupsDialogScope> scope.$new();

    const dialogProps = {
      angularContext: this.angularContextFactory.create(dialogScope),
      dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
      close: (result: any) => modalInstance && modalInstance.close(result),
      groupsToSet: groupsToSet
    };

    modalInstance = ReactModalService.open({
      type: DialogType.Uber,
      dialogContent: React.createElement(UpdateGrantLicenseModeDialog, dialogProps),
      testId: 'localSiteAddUsersDialog',
      showCloseButton: true,
      dialogStyle: groupUpdateDialogStyle,
      shouldNotSetDefaultWidth: false
    });

    modalInstance.result.finally(() => dialogScope.$destroy());

    return modalInstance.result;
  }
}

Module.instance().service('UpdateLocalGroupGrantLicenseModeAction', UpdateLocalGroupGrantLicenseModeAction);
